import {useState} from 'react';
import {Trans} from '../../i18n/trans';
import {UpsellBillingCycle} from './find-best-price';
import {StaticPageTitle} from '../../seo/static-page-title';
import {PricingTable} from '@common/billing/pricing-table/pricing-table';
import {Navbar} from '../../ui/navigation/navbar/navbar';

export function PricingPage() {
  const [selectedCycle, setSelectedCycle] =
    useState<UpsellBillingCycle>('monthly');

  return (
    <div className="pricing-page-wrapper">
      <StaticPageTitle>
        <Trans message="Pricing" />
      </StaticPageTitle>
      <Navbar
        color="bg"
        darkModeColor="bg"
        textColor="text-main"
        border="border-b"
        menuPosition="pricing-table-page"
      />

      {/* Hero Section */}
      <section className="pricing-hero">
        <div className="pricing-hero-label">&#10022; Pricing</div>
        <h1>
          Simple, <em>transparent</em>
          <br />
          pricing
        </h1>
        <p>
          Start building with AI in seconds. Choose the plan that fits your
          needs &mdash; upgrade or downgrade anytime.
        </p>

        {/* Billing Toggle */}
        <div className="pricing-toggle-wrapper">
          <div className="pricing-toggle-track">
            <button
              type="button"
              className={`pricing-toggle-btn ${selectedCycle === 'monthly' ? 'active' : ''}`}
              onClick={() => setSelectedCycle('monthly')}
            >
              Monthly
            </button>
            <button
              type="button"
              className={`pricing-toggle-btn ${selectedCycle === 'yearly' ? 'active' : ''}`}
              onClick={() => setSelectedCycle('yearly')}
            >
              Yearly
            </button>
          </div>
          <span className="pricing-save-badge">Save 20%</span>
        </div>
      </section>

      {/* Pricing Cards */}
      <PricingTable
        selectedCycle={selectedCycle}
        productLoader="pricingPage"
        landingPage={false}
      />

      {/* Footer */}
      <PricingFooter />
    </div>
  );
}

function PricingFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="pricing-footer">
      <div className="pricing-footer-logo">
        <span>Landed</span>
      </div>
      <div className="pricing-footer-links">
        <a href="/about">About</a>
        <a href="/pricing">Pricing</a>
        <a href="/contact">Contact</a>
        <a href="/terms">Terms</a>
        <a href="/privacy">Privacy</a>
        <a href="https://features.landed.net/#changelog">Changelog</a>
        <a href="https://features.landed.net/#requests">Feature Requests</a>
      </div>
      <div className="pricing-footer-copy">
        &copy; {year} Landed &mdash; A{' '}
        <a href="https://mojave.co">Mojave Technologies</a> product
      </div>
    </footer>
  );
}
